import React from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Tooltip from '../../../../../../../../components/Tooltip';

import * as types from '../../reducer/constants';

const FieldRefillRejection = ({ form, dispatchServiceData }) => {
  const {
    refill: { refill_deny_after_rejection },
  } = form;
  const selectedValue = refill_deny_after_rejection ? '1' : '0';

  const onChange = (e) => {
    const value = e.target.value === '1';
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_REJECTION, value });
  };

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="refill_deny_after_rejection">
          Disable refill after rejection
          {' '}
          <Tooltip
            placement="top"
            text={<p>If there was a refill request and it was rejected, the refill button won’t be available for this order again</p>}
            tooltipClass="tooltip__top"
          >
            <span className="fas fa-info-circle cursor-help" />
          </Tooltip>
        </ControlLabel>
        <select
          name="refill_deny_after_rejection"
          id="refill_deny_after_rejection"
          className="form-control"
          value={selectedValue}
          onChange={onChange}
        >
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </FormGroup>
    </>
  );
};

FieldRefillRejection.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
};

export default FieldRefillRejection;
